// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Title-module--cls1--2lHoa","cls2":"styles-Title-module--cls2--3KI3p styles-Title-module--cls1--2lHoa"};